import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title: 'Multiple choice Q&A',
  questionTitle: 'Question',
  questionPlaceholder: 'Enter your question',
  answerTitle: 'Answer',
  answerPlaceholder: 'Add multiple choice answer',
  isCorrectTitle: 'Correct answer?',
  addAnswer: 'Add answer',
  cancel: 'Cancel',
  accept: 'Save',
  generateWithAI: 'Generate with AI assistant',
  assistant: 'AI assistant',
  topicHeading: 'Question topic',
  topicPlaceholder: 'Enter your topic',
  continue: 'Generate',
  select: 'Select',
  Disclamer:
    'Enter a maximum of 4 answer options, with at least 1 correct answer',
  chooseQuestion: 'Choose the question you want to proceed with.',
  gradeWeight: 'Score weight',
  openAIAssistant: 'Open tapybl AI assistant',
  cantGenerate:
    'AI generation is only available for videos uploaded directly to tapybl.',
  difficultyLevel: 'Question difficulty',
};

const welsh = {
  title: 'Holi ac ateb amlddewis',
  questionTitle: 'Cwestiwn',
  questionPlaceholder: 'Rhowch eich cwestiwn',
  answerTitle: 'Ateb',
  answerPlaceholder: 'Ychwanegwch ateb amlddewis',
  isCorrectTitle: 'Ateb cywir?',
  addAnswer: 'Ychwanegwch ateb',
  cancel: 'Canslo',
  accept: 'Cadw',
  generateWithAI: 'Cynhyrchu gyda chynorthwyydd AI',
  assistant: 'Cynorthwy-ydd AI',
  topicHeading: 'Cwestiwn pwnc',
  topicPlaceholder: 'Rhowch eich pwnc',
  continue: 'Nodwch',
  select: 'Dewiswch',
  Disclamer: 'Rhowch uchafswm o 4 opsiwn ateb, gyda o leiaf 1 ateb cywir',
  chooseQuestion: 'Dewiswch y cwestiwn yr ydych am fynd ymlaen ag ef',
  gradeWeight: 'Pwysau sgôr',
  openAIAssistant: 'Agor cynorthwyydd tapybl AI',
};

export const addMChoiceWizardText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
